/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { ReactNode, Suspense, useEffect } from "react";
import Wrapper from "../component/Wrapper";
import Main from "../component/Main";

import Content from "../component/Content";
import Loader from "../component/Loader";
import { Outlet } from "react-router-dom";
import Navbar from "../component/navbar/Navbar";
import Sidebar from "../component/sidebar/Sidebar";
import { SidebarItemsType } from "../types/sidebar";
import {
    DollarSign,
    Handshake,
    ShoppingCart,
    Store,
    Locate,
    Package
} from "lucide-react";
import Footer from "../component/Footer";

interface DashboardProps {
  children?: ReactNode;
}

export const HiTec: React.FC<DashboardProps> = ({ children }) => {


    const appProductSection = [
        {
            href: "/products", 
            icon: Package,
            title: "Products",
        },
        {
            href: "/product_varieties", 
            icon: Package,
            title: "Product Varieties",
        },
        {
            href: "/locations", 
            icon: Locate,
            title: "Locations",
        },
      
    ] as unknown as SidebarItemsType[];

    const appChannelSection = [
        {
            href: "/shopify", 
            icon: Store,
            title: "Shopify",
            children: [
                {
                    href: "/shopify/collections",
                    title: "Collections",
                },                               
                {
                    href: "/shopify/transfers",
                    title: "Transfers",
                },
                {
                    href: "/shopify/gift-cards",
                    title: "Gift Cards",
                },
                {
                    href: "/shopify/catalogs",
                    title: "Catalogs",
                },                
            ],
        },
        {
            href: "/amazon", 
            icon: Store,
            title: "Amazon",
            children: [

            ],
        },    
        {
            href: "/takealot", 
            icon: Store,
            title: "Takealot", 
            children: [

            ],
        },      
        {
            href: "/woocommerce", 
            icon: Store,
            title: "WooCommerce", 
            children: [

            ],
        },   
        {
            href: "/google_merchant_centre", 
            icon: Store,
            title: "Google Merchant Centre", 
            children: [

            ],
        }, 
    ] as unknown as SidebarItemsType[];

    const appAppsSection = [
        {
            href: "/supplier",
            icon: Handshake,
            title: "Supplier Terms",
            children: [
                {
                    href: "/supplier/purchase-orders",
                    title: "Purchase Orders",
                },     
                {
                    href: "/supplier/suppliers",
                    title: "Suppliers",
                },
                {
                    href: "/supplier/triggers",
                    title: "Triggers",
                },                                           
            ],
        },
      
    ] as unknown as SidebarItemsType[];

    const navItems = [
        {
            title: "Products:",
            pages: appProductSection,
        },
        {
            title: "Channel Application Data:",
            pages: appChannelSection,
        },
        {
            title: "Apps Section:",
            pages: appAppsSection,
        }
    ];

    return (
    
        <React.Fragment>
            <Wrapper>
                <Sidebar items={navItems} showFooter={false} />
                <Main>
                    <Navbar />
                    {/* <Body /> */}
                    <Content>
                        <Suspense fallback={<Loader />}>
                            {children}
                            <Outlet />
                        </Suspense>
                    </Content>
                    <Footer />
                </Main>
            </Wrapper>
        </React.Fragment>
    )
};
